import { Link } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";
import { IMAGES } from "../../data/images";
import "./layout.css";

export default function PageHeader({ title, crumbs = [], bg }) {
  return (
    <section
      className="page-header"
      style={{ backgroundImage: `linear-gradient(rgba(10,10,10,.82),rgba(10,10,10,.88)), url(${bg || IMAGES.cityNight})` }}
    >
      <div className="container">
        <h1>{title}</h1>
        <div className="breadcrumb">
          <Link to="/">Home</Link>
          {crumbs.map((c, i) => (
            <span key={i} className="crumb">
              <FaChevronRight />
              {c.to ? <Link to={c.to}>{c.label}</Link> : <span>{c.label}</span>}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
